import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Destination route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} DestinationRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/destinations",
        name: "Destinations",
        meta: {
            title: "Destinations",
            modules: ["destinations"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "destinations" */ "@/modules/destinations/pages/Destinations"
            )
    },
    {
        path: "/destinations/new",
        name: "NewDestination",
        meta: {
            title: "New Destination",
            modules: ["destinations"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "destinations" */ "@/modules/destinations/pages/NewDestination"
            )
    },
    {
        path: `/destinations/${idParam()}`,
        name: "Destination",
        meta: {
            title: "Destination",
            modules: ["destinations"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "destinations" */ "@/modules/destinations/pages/EditDestination"
            )
    },
    {
        path: "/suppliers/:id/destinations",
        name: "DestinationsOfSupplier",
        meta: {
            title: "Destinations Of Supplier",
            modules: ["suppliers"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "destinations" */ "@/modules/destinations/pages/DestinationsOfSupplier"
            )
    }
]